import PropTypes from 'prop-types';
import HighCharts from '../HighCharts';

import s from './TreeMapChartBlock.module.css';

const TreeMapChartBlock = ({
    title,
    showTitleInToc,
    displayLargeTitle,
    layoutAlgorithm,
    propertySeriesQueries,
    aggregateSeriesQueries,
    dynamicProperty,
    borderWidth,
    borderColor,
}) => {
    const plotOptions = {
        treemap: {
            dataLabels: {
                style: {
                    textOutline: 'none',
                    fontSize: '14px',
                },
            },
        },
    };

    return (
        <div className={s.Root}>
            <HighCharts
                chartType="treemap"
                treeMapLayoutAlgorithm={layoutAlgorithm}
                title={title}
                showTitleInToc={showTitleInToc}
                displayLargeTitle={displayLargeTitle}
                propertySeriesQueries={propertySeriesQueries}
                aggregateSeriesQueries={aggregateSeriesQueries}
                dynamicProperty={dynamicProperty}
                plotOptions={plotOptions}
                treeMapBorderWidth={borderWidth}
                treeMapBorderColor={borderColor}
            />
        </div>
    );
};

TreeMapChartBlock.propTypes = {
    title: PropTypes.string,
    showTitleInToc: PropTypes.bool,
    displayLargeTitle: PropTypes.bool,

    layoutAlgorithm: PropTypes.string,

    propertySeriesQueries: PropTypes.array,
    aggregateSeriesQueries: PropTypes.array,

    dynamicProperty: PropTypes.string,
};

export default TreeMapChartBlock;
